import React from 'react';

const PropertyStatsCard = ({ data }) => {
	if (!data) {
		return (
			<div className="alert alert-info">
				No statistics available for this property.
			</div>
		);
	}

	const { totalJobs, uniqueJobTypes, bisJobs, odJobs, date } = data;

	return (
		<div className="property-stats-card">
			<div className="row g-3 mb-4">
				<div className="col-md-3 col-6">
					<div className="stats-box text-center p-3 border rounded bg-light">
						<div className="text-muted small mb-1">Total Jobs</div>
						<div className="h3 mb-0 fw-bold text-primary">{totalJobs || 0}</div>
					</div>
				</div>
				<div className="col-md-3 col-6">
					<div className="stats-box text-center p-3 border rounded bg-light">
						<div className="text-muted small mb-1">Unique Types</div>
						<div className="h3 mb-0 fw-bold text-info">
							{uniqueJobTypes || 0}
						</div>
					</div>
				</div>
				<div className="col-md-3 col-6">
					<div className="stats-box text-center p-3 border rounded bg-light">
						<div className="text-muted small mb-1">BIS Jobs</div>
						<div className="h3 mb-0 fw-bold text-success">
							{bisJobs?.total || 0}
						</div>
						<div className="small text-muted">{bisJobs?.unique || 0} types</div>
					</div>
				</div>
				<div className="col-md-3 col-6">
					<div className="stats-box text-center p-3 border rounded bg-light">
						<div className="text-muted small mb-1">Open Data Jobs</div>
						<div className="h3 mb-0 fw-bold text-warning">
							{odJobs?.total || 0}
						</div>
						<div className="small text-muted">{odJobs?.unique || 0} types</div>
					</div>
				</div>
			</div>

			<div className="row g-3">
				<div className="col-md-6">
					<div className="card border bg-light">
						<div className="card-body">
							<h6 className="card-title text-success">
								<i className="bi bi-building me-2"></i>
								BIS Jobs Summary
							</h6>
							<div className="d-flex justify-content-between align-items-center mt-3">
								<div>
									<div className="small text-muted">Total Executions</div>
									<div className="h5 mb-0">{bisJobs?.total || 0}</div>
								</div>
								<div>
									<div className="small text-muted">Success Rate</div>
									<div className="h5 mb-0 text-success">
										{bisJobs?.successRate || 0}%
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="col-md-6">
					<div className="card border bg-light">
						<div className="card-body">
							<h6 className="card-title text-primary">
								<i className="bi bi-database me-2"></i>
								Open Data Jobs Summary
							</h6>
							<div className="d-flex justify-content-between align-items-center mt-3">
								<div>
									<div className="small text-muted">Total Executions</div>
									<div className="h5 mb-0">{odJobs?.total || 0}</div>
								</div>
								<div>
									<div className="small text-muted">Success Rate</div>
									<div className="h5 mb-0 text-success">
										{odJobs?.successRate || 0}%
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			{date && (
				<div className="text-muted text-center mt-3 small">
					Statistics for {date}
				</div>
			)}
		</div>
	);
};

export default PropertyStatsCard;
